
import { Section,SectionTitle, SectionTitle2, GradCard1,GradCard2  } from "../components/reuseable"

import { useAuth } from "../app/context";

const ProfessionalBackground = () =>{

  let { isLoaded,professional, translations } = useAuth();

  return(
    <Section id="professional">
      <SectionTitle title={translations.professional.title} ts="3"/>

        {!!isLoaded && <div className="grid-cols-1 grid-cols-md-2 gap-32 my-40 sm:my-48">
          <GradCard1 className="gradient-bc-3c">
            <div className="flex-row-60 h-60 items-center justify-center mx-auto fs-20 br-12 shadow-md mb-16" style={{background: "var(--gradient-secondary)"}}>💻</div>
            <div className="block-full font-inter fw-600 fs-24 lh-30 color-highlight-3 mb-16">
              {professional.items[0].title}
            </div>
            <div className="block-full font-inter fw-600 fs-16 lh-20 color-dark mb-8">
              <div className="inline-auto color-strong mr-8">{translations.professional.tabs[0]}:</div>
              <div className="inline-auto color-accent">{professional.items[0].experience}</div>
            </div>
            <div className="block-full font-inter fs-16 lh-24 mb-16 color-soft text-justify">{professional.items[0].description[0]}</div>
            <div className="block-full font-inter fs-16 lh-24 color-soft text-justify">{professional.items[0].description[1]}</div>
          </GradCard1>
          <GradCard1 className="gradient-bc-3c">
            <div className="flex-row-60 h-60 items-center justify-center mx-auto fs-20 br-12 shadow-md mb-16" style={{background: "var(--gradient-secondary)"}}>💡</div>
            <div className="block-full font-inter fw-600 fs-24 lh-30 color-highlight-3 mb-16">{professional.items[1].title}</div>
            <div className="block-full font-inter fs-16 lh-24 mb-16 color-soft text-justify">{professional.items[1].description[0]}</div>
            <div className="block-full font-inter fs-16 lh-24 color-soft text-justify">{professional.items[1].description[1]}</div>
          </GradCard1>
        </div>}

        {!!isLoaded && <SectionTitle2 title={translations.professional.title2} ts="3"/>}


        {!!isLoaded && <div className="grid-cols-1 grid-cols-md-2 grid-cols-lg-3 grid-cols-xl-4 gap-24 lg:gap-32 mt-32 mb-48">
          {(professional?.keyStrengths??[]).map((strength, index) => (
            <div key={index} className="block-full br-12 p-1 pl-4 gradient-bc-3c-2 shadow-md text-left">
              <div className="block-full h-full bg-surface-1 color-soft p-16 fs-16 lh-20 br-12">
                <span className="color-highlight-2 mr-8">✓</span>
                {strength}
              </div>
            </div>
          ))}
        </div>}

        {!!isLoaded && <GradCard2 className="gradient-bc-3c-2 pt-6 sm:pt-8">
          <h3 className="block-full mb-16 fs-28 m:fs-32 lh-none font-inter fw-600 color-header-2 text-left">
          {professional.extras[0].emoji} {professional.extras[0].title}
          </h3>
          <div className="block-full fs-16 lh-24 font-inter color-soft text-left">{professional.extras[0].description}</div>
          <hr className="block-full bw-1 bs-solid bc-muted opacity-20 my-16 md:my-24" />
          <h4 className="block-full mb-16 fs-24 lh-none font-inter fw-600 color-header-2 text-left">
            {professional.extras[1].emoji} {professional.extras[1].title}
          </h4>
          <div className="block-full fs-16 lh-24 font-inter color-soft text-left">{professional.extras[1].description}</div>
        </GradCard2>}

    </Section>
  )
}

export default ProfessionalBackground;
